import title from "../../images/imagePopup/visualInformation/1_localscadasettings.png";
import SCADASCLMenu from "../../images/SCADASCLMenu.png";
import SCADASCLMenuAVIF from "../../images/SCADASCLMenu.avif";
import SCADALogic from "../../images/SCADALogic.png";
import SCADALogicAVIF from "../../images/SCADALogic.avif";

import Layout from "../../components/mainPage/Layout";
import { MinDigitsBrand } from "shared/components/MinDigitsBrand";
import Parameters from "shared/components/Parameters";


export function Page({ openPopup }) {
  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <div className="d-flex justify-content-between flex-wrap">
            <h1 className="mb-4 ">
              SCADA Studio
            </h1>
            <MinDigitsBrand id="305144" />
          </div>

          <Parameters
            title=""
            image={title}
            // images={images}
            openPopup={openPopup}
            zoomColor="white"
          >
            <p>
              <b>SCADA Studio</b> - единая среда автоматизированного проектирования и конфигурирования для программирования контроллеров (с поддержкой всех языков МЭК 61131) и настройки SCADA, включая создание проектов МЭК 61850.
            </p>

            <p>SCADA Studio позволяет выполнить настройки в едином интерфейсе для всех уровней АСУ ТП:</p>
            <ul>
              <li>Настройки проекта SCADA</li>
              <li>Настройки станционного контроллера связи и управления (СКСУ)</li>
              <li>Настройки контроллеров присоединения и других устройств</li>
            </ul>


            <p>
              Для настройки проекта SCADA вместе с ПО SCADA Studio поставляется локальная версия SCADA для АРМ. Интерфейс локальной версии SCADA повторяет серверную SCADA, что позволяет подготовить и  проверить выполненные настройки до отправки на сервер SCADA.
            </p>
            <p>
              Опрос устройств по промышленным протоколам осуществляется с помощью программного обеспечения станционного контроллера связи и управления (ПО СКСУ). Передача данных в SCADA осуществляется по внутреннему протоколу СКСУ. Передача данных по внутреннему протоколу настраивается с помощью SCADA Studio.
            </p>
            <h3>
              Настройки станционного контроллера связи и управления (СКСУ)
            </h3>
            <p>
              Настройка опроса устройств со станционного контроллера связи и управления осуществляется с помощью библиотек устройств, которые могут быть сформированы из файлов конфигурации, выгруженных с устройств. В случае МЭК 61850 это файл CID в соответствии со стандартом МЭК 61850-6 (SCL).
            </p>
            <p>
              При необходимости файл CID может быть сформирован с помощью редактора файла конфигурации SCL, встроенного в SCADA Studio.
            </p>
            <h3>
              Редактор файла конфигурации SCL
            </h3>

            <p>
              Редактор файла конфигурации SCL в SCADA Studio позволяет выполнять автоматизированное проектирование коммуникационных сетей и систем подстанций с использованием языка SCL в соответствии со стандартом МЭК 61850-6.
            </p>
            <p>
              Для выполнения привязки логических узлов SCADA Studio поддерживает стандартные логические узлы, указанные в стандарте МЭК 61850, а также позволяет добавить узлы, соответствующие корпоративному профилю Заказчика.
            </p>
            <p>
              SCADA Studio позволяет автоматизировать привязку сигналов к первичному оборудованию с использованием автоматического импорта данных из файла конфигурации SCL.
            </p>
            <picture style={{ display: 'block', width: '100%' }} >
              <source srcSet={SCADASCLMenuAVIF} type="image/avif" />
              <img
                src={SCADASCLMenu}
                loading="lazy"
                style={{ width: '100%', objectFit: 'cover', height: '100%', padding: '0' }}
              ></img>
            </picture>
            <h3>Настройка логики</h3>
            <p>
              Для настройки логики устройства SCADA Studio поддерживает логические блоки на всех языках стандарта МЭК 61131-3:
            </p>
            <ul>
              <li>Структурированный текст (ST - Structured Text)</li>
              <li>Последовательные функциональные схемы (SFC - Sequential Function Chart)</li>
              <li>Диаграммы функциональных блоков (FBD - Function Block Diagram)</li>
              <li>Релейно-контактные схемы, или релейные диаграммы (LD - Ladder Diagram)</li>
              <li>Список инструкций (IL - Instruction List)</li>
            </ul>
            <p>
              Проверка логических блоков в SCADA Studio осуществляется с помощью продвинутого отладчика. Отладчик позволяет сформировать необходимый сценарий изменения входных переменных для контроля значений на выходе алгоритма.
            </p>
            <picture style={{ display: 'block', width: '100%' }} >
              <source srcSet={SCADALogicAVIF} type="image/avif" />
              <img
                src={SCADALogic}
                loading="lazy"
                style={{ width: '100%', objectFit: 'cover', height: '100%', padding: '0' }}
              ></img>
            </picture>
            {/* <a className="text-links" href="https://epsa-spb.ru/kontakty-2/">Запросить референс лист</a> */}
          </Parameters>
        </div>
      </div>
    </Layout>

  );
}

